export const isStaffManagementForbidden = (error) => {
    const errors = [error, ...(error?.graphQLErrors || []), ...(error?.errors || []),
        ...(error?.networkError?.result?.errors || [])];
    return Number(error?.networkError?.statusCode || error?.networkError?.status || error?.statusCode || error?.status) === 403 ||
        errors.some((item) => item?.code === "FORBIDDEN" || item?.extensions?.code === "FORBIDDEN" ||
            Number(item?.extensions?.status) === 403 || /(?:^|\\)AuthorizationException$/.test(item?.extensions?.class || ""));
};

export const requestStaffManagement = async (operation) => {
    try {
        const result = await operation();
        if (result?.errors?.length) throw Object.assign(new Error("GraphQL request failed"), { graphQLErrors: result.errors });
        return result;
    } catch (error) {
        if (isStaffManagementForbidden(error)) throw Object.assign(new Error("FORBIDDEN"), { code: "FORBIDDEN", cause: error });
        throw error;
    }
};
